module.exports = __webpack_public_path__ + "static/img/3113-01.c44d98a4.jpg";